export default {
  props: {
    data: Object
  }
};